<template>
    <div class="pay">
        <div class="pay-title">{{ payTitle }}</div>
        <img class="img" :src="imgpath" alt="">
        <div class="txttip">
            <div class="lefttext">二维码有效期：<span>{{timestring}}</span></div>
            <div class="righttext">支付<span>{{money}}</span>元</div>
        </div>
        <div class="qrimg">
            <img :src="$store.state.basicurl+img" alt="">
        </div>
        <div class="tipimg">
            <img v-if="imgtippath" :src="imgtippath" alt="">
            <p v-else class="pay-tip-text">{{ payTipText }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PayVue",
    props:["img","money",'paytype'],
    data() {
        return {
            mytime: 7200,
        }
    },
    mounted(){
        var times = setInterval( () =>{
            this.mytime-=1
            if (this.mytime <= 0) {
                clearInterval(times)
            }
        }, 1000)      
    },   
    computed: {
        timestring(){
            var h=parseInt(this.mytime/3600)
            var m=parseInt(this.mytime%3600/60)
            var s=this.mytime%3600%60
            return h+"时"+m+"分"+s+"秒"
        },
        imgpath(){
            if(this.paytype=="wepay")
            return "./assets/wepay.png"
            else
            return "./assets/alipay.png"
        },
        imgtippath(){
            if(this.paytype=="wepay")
            return "./assets/wepaytip.png"
            else
            return "./assets/alipaytip.png"
        },
        payTitle() {
            return this.paytype === 'wepay' ? '微信扫码支付' : '支付宝扫码支付'
        },
        payTipText() {
            return this.paytype === 'wepay' ? '请使用微信扫一扫完成支付' : '请使用支付宝扫一扫完成支付'
        }
    }
}
</script>

<style scoped>
    @media(max-width: 768px){
    .pay{
        width:80vw;
        margin: 0 auto;
        font: 12px/18px Verdana,Geneva,borderTNArail,"\5FAE\8F6F\96C5\9ED1";
        color: #606266;
        font-size: 14px;
    }
    .txttip{
        margin-left: 1vw;
        margin-right: 1vw;
        height: 5vh;
    }
    .txttip .lefttext{
        float: left;
    }
    .txttip .righttext{
        float: right;
    }
    .txttip .righttext span,.txttip .lefttext span{
        color: red;
    }
    .txttip .righttext span{
        font-size: 18px;
        margin-left:1vw;
        margin-right: 1vw;
    }
    .qrimg,.tipimg{
        display: flex;
        justify-content: center;
    }
    .tipimg{
        margin-top: 1vw;
    }
    .pay-title { font-weight: 600; font-size: 16px; margin-bottom: 8px; text-align: center; }
    .pay-tip-text { color: #909399; font-size: 13px; margin: 0; }
    }
    @media(min-width: 769px){
    .pay{
        width: 620px;
        margin: 0 auto;
        font: 12px/18px Verdana,Geneva,borderTNArail,"\5FAE\8F6F\96C5\9ED1";
        color: #606266;
        font-size: 14px;
    }
    .txttip{
        margin-left: 32px;
        margin-right: 32px;
        height: 25px;
    }
    .txttip .lefttext{
        float: left;
    }
    .txttip .righttext{
        float: right;
    }
    .txttip .righttext span,.txttip .lefttext span{
        color: red;
    }
    .txttip .righttext span{
        font-size: 18px;
        margin-left: 5px;
        margin-right: 5px;
    }
    .qrimg,.tipimg{
        display: flex;
        justify-content: center;
    }
    .tipimg{
        margin-top: 20px;
    }
    .pay-title { font-weight: 600; font-size: 18px; margin-bottom: 12px; text-align: center; }
    .pay-tip-text { color: #909399; font-size: 14px; margin: 0; }
}
</style>

<!-- 暗黑模式适配 -->
<style>
.dark-mode .pay { color: var(--text-regular); }
.dark-mode .pay .pay-title { color: var(--text-primary); }
.dark-mode .pay .txttip .lefttext,
.dark-mode .pay .txttip .righttext { color: var(--text-regular); }
.dark-mode .pay .pay-tip-text { color: var(--text-secondary); }
.dark-mode .pay .qrimg { background: #fff; border-radius: 6px; padding: 4px; }
</style>